export function initPasswordToggle(): void {
  const passwordToggleContainers = document.querySelectorAll<HTMLElement>('[data-component="password-toggle"]');

  passwordToggleContainers.forEach(toggleContainer => {
    const passwordInput = toggleContainer.querySelector<HTMLInputElement>('.authentication-form__input');
    const button = toggleContainer.querySelector<HTMLButtonElement>('.authentication-form__toggle-password');

    if (!passwordInput || !button) return;

    button.addEventListener('click', () => {
      const eyeSolidIcon = button.querySelector<SVGElement>('.authentication-form__toggle-password-icon--eye-solid');
      const eyeClosedIcon = button.querySelector<SVGElement>('.authentication-form__toggle-password-icon--eye-closed');

      if (eyeSolidIcon && eyeClosedIcon) {
        eyeSolidIcon.style.display = passwordInput.type === 'password' ? 'block' : 'none';
        eyeClosedIcon.style.display = passwordInput.type === 'password' ? 'none' : 'block';
      }

      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        button.setAttribute('aria-label', 'Hide password');
      } else {
        passwordInput.type = 'password';
        button.setAttribute('aria-label', 'Show password');
      }
    });
  });
}

// Auto-initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPasswordToggle);
} else {
  initPasswordToggle();
}
